export { goToNextCell } from './goToNextCell';
export { addRowAfter } from './addRowAfter';
export { addColumnAfter } from './addColumnAfter';
export { appendRow } from './appendRow';
export { appendColumn } from './appendColumn';
export { removeColumn } from './removeColumn';
export { removeCurrentColumn } from './removeCurrentColumn';
export { removeRow } from './removeRow';
export { removeCurrentRow } from './removeCurrentRow';
export { transpose } from './transpose';
